import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LanguageComponent } from '../toolbar/language/language.component';
import { LocaleService, TranslationService, Language, DefaultLocale, Currency } from 'angular-l10n';
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent implements OnInit {

  constructor(public locale: LocaleService,public dialog: MatDialog, public translation: TranslationService) { }

  ngOnInit() {
  }

openLanguageDialog() {
    const dialogRef = this.dialog.open(LanguageComponent, {
      height: '50%',
      width: '50%'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }



}
